import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-727f003d"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "component-tree-wrapper" };
const _hoisted_2 = { class: "component-tree-wrapper__title" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h1", { class: "icon-wrapper" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa-kit fa-variable-instance-unlinked" })
], -1 /* HOISTED */));
const _hoisted_4 = {
    key: 0,
    class: "component-tree-wrapper__tree"
};
import { useBuiltComponentVariable } from "src/shared/store/component-built/composables";
import { useComponentTree } from "src/shared/store/component-graph-v2/composables/useComponentTree";
import { toRef } from "vue";
import ComponentTreeNode from "./ComponentTreeNode.vue";
import CreateOrDeleteComponentVariableCheckbox from "./CreateOrDeleteComponentVariableCheckbox.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ComponentVariableManagementTree',
    props: {
        componentId: {},
        variableName: {},
        activeComponentIds: {}
    },
    setup(__props) {
        const props = __props;
        const { builtComponentVariable } = useBuiltComponentVariable(toRef(props, "componentId"), toRef(props, "variableName"));
        const tree = useComponentTree(toRef(props, "componentId"));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _renderSlot(_ctx.$slots, "title")
                ]),
                (_unref(tree))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tree).children, (child, index) => {
                            return (_openBlock(), _createBlock(ComponentTreeNode, {
                                key: child.componentId,
                                tree: child,
                                "is-last-child": index === _unref(tree).children.length - 1,
                                "is-top": index === 0,
                                "active-component-ids": props.activeComponentIds
                            }, {
                                prefix: _withCtx(({ componentId }) => [
                                    (_unref(builtComponentVariable))
                                        ? (_openBlock(), _createBlock(CreateOrDeleteComponentVariableCheckbox, {
                                            key: 0,
                                            "component-id": componentId,
                                            "variable-name": _ctx.variableName,
                                            "variable-display-name": _unref(builtComponentVariable).getDisplayName(),
                                            type: _unref(builtComponentVariable).type
                                        }, null, 8 /* PROPS */, ["component-id", "variable-name", "variable-display-name", "type"]))
                                        : _createCommentVNode("v-if", true)
                                ]),
                                line: _withCtx(({ componentId }) => [
                                    _renderSlot(_ctx.$slots, "master", { componentId: componentId })
                                ]),
                                _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["tree", "is-last-child", "is-top", "active-component-ids"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
